import { PagingResultsViewModel } from '../../../core/_infrastructure/types/common';

export class PaisFrItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PaisFrItemViewModel[];
}

export class PaisFrItemViewModel {
    public Id: number;
    public NombrePais: string = '';
    public IdGrupoPaisesFr: number | null = null;
    public NombreGrupoPaisesFr: string = '';
}

export class PaisFrViewModel {
    constructor() {}

    public Id: number;
    public IdPais: number | null = null;
    public NombrePais: string = '';
    public IdGrupoPaisFr: number | null = null;
    public NombreGrupoPaisesFr: string = '';
}
